import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Response } from '../../../../_shared/models/response.model';
import { MaintenanceConfigurationResponse } from '../models/maintenance-configuration-response.model';
import { UpsertConfigurationRequest } from '../models/maintenance-configuration-request.model';

@Injectable({ providedIn: 'root' })
export class MaintenanceConfigurationService {
  private http = inject(HttpClient);

  async getConfiguration(accountId: number, cancelSubject: Subject<void>): Promise<Response<MaintenanceConfigurationResponse>> {
    return await firstValueFrom(
      this.http.get(`${environment.apiEndpoint}/maintenancesettings/maintenance-configuration/${accountId}`).pipe(takeUntil(cancelSubject))
    );
  }

  async upsertConfiguration(config: UpsertConfigurationRequest): Promise<Response<MaintenanceConfigurationResponse>> {
    return await firstValueFrom(
      this.http.post(`${environment.apiEndpoint}/maintenancesettings/maintenance-configuration`, config)
    );
  }
}